import { singularize } from './case';

// TODO: Add this functionality to vuex-orm/plugin-axios?
// See https://github.com/vuex-orm/plugin-axios
export default function formatJsonApiData(modelOrEntity, attributes) {
  const typeName =
    typeof modelOrEntity === 'string' ? modelOrEntity : modelOrEntity.entity;

  return {
    data: {
      type: singularize(typeName),
      attributes,
    },
  };
}
